import { CreditCard, Fingerprint, Layers, Mail, QrCode, UserCheck } from "lucide-react";

const ITEMS = [
  { icon: CreditCard, title: "Digital Business Card", text: "Create a professional digital card that represents you wherever you connect." },
  { icon: UserCheck, title: "Public Professional Profile", text: "Turn your professional identity into a shareable profile with your information, links, company details, and contact options." },
  { icon: Fingerprint, title: "Professional Identity", text: "Keep your name, role, company, contact details, bio, photo, logo, and professional links organized in one place." },
  { icon: Mail, title: "Email Signature", text: "Extend the same professional identity into your everyday email communication." },
  { icon: QrCode, title: "Shareable QR Identity", text: "Give people a simple way to reach your professional profile through your MetWorth QR identity." },
  { icon: Layers, title: "Professional Presence", text: "Build one consistent identity that can be presented across different professional touchpoints." },
];

export function WhatIsSection() {
  return (
    <section data-testid="landing-what-is" className="border-t border-border">
      <div className="mx-auto w-full max-w-7xl px-6 py-20 sm:px-10 lg:py-28">
        <p className="mw-eyebrow">What is MetWorth?</p>
        <h2 className="mt-4 max-w-2xl font-serif text-3xl tracking-tight sm:text-5xl">Your professional identity, remembered.</h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">
          MetWorth brings your professional identity into one complete digital presence — from your digital business card and public profile to the places where you work, connect, and share.
        </p>
        <ul className="mt-16 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
          {ITEMS.map(({ icon: Icon, title, text }) => (
            <li key={title} className="border-t border-border pt-6">
              <Icon className="h-5 w-5 text-gold" strokeWidth={1.5} aria-hidden="true" />
              <h3 className="mt-5 font-serif text-xl tracking-tight">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
